// extracted by mini-css-extract-plugin
export default {"container":"engObj_container__6DT2Z","h1":"engObj_h1__crZL2","p":"engObj_p__As7Fz","imgContainer":"engObj_imgContainer__jWW6N","img":"engObj_img__inM4D"};